"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createHostContentShareObserver = createHostContentShareObserver;
exports.createSpeakerContentShareObserver = createSpeakerContentShareObserver;
var _logger = require("@studio/logger");
var _constants = require("../../constants");
function createHostContentShareObserver(dispatch, createScreenShareSource, meetingResponse, attendeeResponse) {
  var meetingId = meetingResponse.Meeting.MeetingId;
  var attendeeId = attendeeResponse.Attendee.AttendeeId;
  return {
    contentShareDidStart: function contentShareDidStart() {
      dispatch(createScreenShareSource());
      var logPayload = {
        chimeEventName: 'contentShareDidStart',
        'studio.meeting.id': meetingId,
        title: "Screen share process started by attendee ".concat(attendeeId, " from meeting id: ").concat(meetingId)
      };
      (0, _logger.sendToDatadog)(_constants.loggerName, logPayload, logPayload.title, false);
    },
    contentShareDidStop: function contentShareDidStop() {
      var logPayload = {
        chimeEventName: 'contentShareDidStop',
        'studio.meeting.id': meetingId,
        title: "Screen share process stopped by attendee ".concat(attendeeId, " from meeting id: ").concat(meetingId)
      };
      (0, _logger.sendToDatadog)(_constants.loggerName, logPayload, logPayload.title, false);
    },
    contentShareDidPause: function contentShareDidPause() {
      var logPayload = {
        chimeEventName: 'contentShareDidPause',
        'studio.meeting.id': meetingId,
        title: "Screen share paused for attendee ".concat(attendeeId, " in meeting ").concat(meetingId)
      };
      (0, _logger.sendToDatadog)(_constants.loggerName, logPayload, logPayload.title, false);
    },
    contentShareDidUnpause: function contentShareDidUnpause() {
      var logPayload = {
        chimeEventName: 'contentShareDidUnpause',
        'studio.meeting.id': meetingId,
        title: "Screen share unpaused for attendee ".concat(attendeeId, " in meeting ").concat(meetingId)
      };
      (0, _logger.sendToDatadog)(_constants.loggerName, logPayload, logPayload.title, false);
    }
  };
}
function createSpeakerContentShareObserver(dispatch, setScreenShareActive, meetingResponse, attendeeResponse) {
  var meetingId = meetingResponse.Meeting.MeetingId;
  var attendeeId = attendeeResponse.Attendee.AttendeeId;
  return {
    contentShareDidStart: function contentShareDidStart() {
      var logPayload = {
        chimeEventName: 'contentShareDidStart',
        'studio.meeting.id': meetingId,
        title: "Content share started for attendee ".concat(attendeeId, " in meeting ").concat(meetingId)
      };
      (0, _logger.sendToDatadog)(_constants.loggerName, logPayload, logPayload.title, false);
      dispatch(setScreenShareActive(true));
    },
    contentShareDidStop: function contentShareDidStop() {
      var logPayload = {
        chimeEventName: 'contentShareDidStop',
        'studio.meeting.id': meetingId,
        title: "Content share stopped for attendee ".concat(attendeeId, " in meeting ").concat(meetingId)
      };
      (0, _logger.sendToDatadog)(_constants.loggerName, logPayload, logPayload.title, false);
      dispatch(setScreenShareActive(false));
    },
    contentShareDidPause: function contentShareDidPause() {
      var logPayload = {
        chimeEventName: 'contentShareDidPause',
        'studio.meeting.id': meetingId,
        title: "Content share paused for attendee ".concat(attendeeId, " in meeting ").concat(meetingId)
      };
      (0, _logger.sendToDatadog)(_constants.loggerName, logPayload, logPayload.title, false);
    },
    contentShareDidUnpause: function contentShareDidUnpause() {
      var logPayload = {
        chimeEventName: 'contentShareDidUnpause',
        'studio.meeting.id': meetingId,
        title: "Content share unpaused for attendee ".concat(attendeeId, " in meeting ").concat(meetingId)
      };
      (0, _logger.sendToDatadog)(_constants.loggerName, logPayload, logPayload.title, false);
    }
  };
}